import { computed, ref, watch } from 'vue';
import { defineStore } from 'pinia';

export type ThemeName = 'light' | 'dark';

const storageKey = 'mentoai-theme';

function savedTheme(): ThemeName {
  try {
    return localStorage.getItem(storageKey) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<ThemeName>(savedTheme());
  const isDark = computed(() => theme.value === 'dark');

  function apply(): void {
    document.documentElement.dataset.theme = theme.value;
    document.documentElement.style.colorScheme = theme.value;
    const background = theme.value === 'dark' ? '#171717' : '#ffffff';
    const headerBackground = theme.value === 'dark' ? '#242424' : '#171717';
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', headerBackground);
    const webApp = window.Telegram?.WebApp;
    webApp?.setHeaderColor?.(headerBackground);
    webApp?.setBackgroundColor?.(background);
  }

  function toggle(): void {
    theme.value = theme.value === 'light' ? 'dark' : 'light';
  }

  function setTheme(next: ThemeName): void {
    theme.value = next;
  }

  watch(theme, () => {
    try { localStorage.setItem(storageKey, theme.value); } catch { /* Storage can be unavailable in private contexts. */ }
    apply();
  }, { flush: 'sync' });

  apply();
  return { theme, isDark, toggle, setTheme, apply };
});
